import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData, selectMerchantInfo } from '../../../../store/termsAndConditions/termsAndConditionsSlice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import React, { useEffect, useState } from 'react';
import { PageWithLoader } from 'pages/PageWithLoader';
import { getJwtParam } from 'utils';
import { LoyaltyPrivacyPolicyEN } from './PrivacyPolicy/PrivacyPolicyEN';
import { LoyaltyPrivacyPolicyFR } from './PrivacyPolicy/PrivacyPolicyFR';

export const GeniusCALoyaltyPrivacyPolicy = () => {
  const FRENCH_LOCALES: string[] = ['fr-CA', 'fr_CA'];
  const defaultLocale: string = 'en-US';

  const [searchParams, setSearchParams] = useSearchParams();
  const [locale, setLocale] = useState(defaultLocale);

  const merchantInfo = useSelector(selectMerchantInfo);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    const account = searchParams.get('account');
    const jwt = searchParams.get('jwt');

    if (account && jwt) {
      dispatch(fetchData({ account, jwt }));
      setLocale(getJwtParam(jwt, 'locale', defaultLocale));
    }
  }, [dispatch, searchParams, setSearchParams]);

  return (
    <PageWithLoader>
      {FRENCH_LOCALES.includes(locale) ? (
        <LoyaltyPrivacyPolicyFR {...merchantInfo} />
      ) : (
        <LoyaltyPrivacyPolicyEN {...merchantInfo} />
      )}
    </PageWithLoader>
  );
};
